import React, { useEffect, useState } from "react";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import { useDispatch, useSelector } from "react-redux";
import {
  AddWpSetupDetail,
  DeleteWpSetupDetail,
  fetchWpSetupAll,
  fetchWpSetupDetailAll,
  UpdateWpSetupDetail,
} from "../../Redux/WhatsappSlice/WhatsappApiSetup";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const Wp_Setup_Details = () => {
  const dispatch = useDispatch();

  const { WpSetupData, WpSetupDetailData } = useSelector(
    (state) => state.WpApiSetup
  );

  const [formData, setFormData] = useState({
    WhatsappOffcialName: "",
    Parameter: "",
    ISURL: false,
    IsMobile: false,
  });

  const [selectedId, setSelectedId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchWpSetupAll());
    dispatch(fetchWpSetupDetailAll());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = (formData) => {
    const errors = {};

    if (
      !formData.WhatsappOffcialName ||
      formData.WhatsappOffcialName.trim() === ""
    ) {
      errors.WhatsappOffcialName = "Select Name Required";
    }

    if (!formData.Parameter || formData.Parameter.trim() === "") {
      errors.Parameter = "Parameter is required";
    }

    return errors;
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this record?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteWpSetupDetail({ id: row.MainId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchWpSetupDetailAll()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleEdit = (row) => {
    setEditId(row.MainId);
    setFormData({
      WhatsappOffcialName: row.WhatsappOffcialName,
      Parameter: row.Parameter,
      ISURL: row.ISURL === "True",
      IsMobile: row.IsMobile === "True",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (editId) {
          await dispatch(
            UpdateWpSetupDetail({ id: editId, formData })
          ).unwrap();
          toast.success("Whatsapp Setup Detail updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(
            AddWpSetupDetail({ selectedId, values: formData })
          ).unwrap();
          toast.success("Whatsapp Setup Detail added successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          WhatsappOffcialName: "",
          Parameter: "",
          ISURL: false,
          IsMobile: false,
        });
        setSelectedId(null);
        dispatch(fetchWpSetupDetailAll());
      } catch (error) {
        toast.error(
          `Failed to ${editId ? "update" : "add"} Whatsapp Setup Detail: ${
            error.message || "Unknown error"
          }`,
          {
            position: "top-right",
            autoClose: 1000,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    {
      field: "WhatsappOffcialName",
      headerName: "Whatsapp Offcial Name",
      flex: 1,
    },
    { field: "Parameter", headerName: "Parameter", flex: 1 },
    { field: "ISURL", headerName: "IsURL", flex: 1 },
    { field: "IsMobile", headerName: "IsMobile	", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = (WpSetupDetailData || [])?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    WhatsappOffcialName: el?.WhatsAppOffcialWaID?.WhatsappOffcialName,
    Parameter: el?.Parameter,
    ISURL: el?.ISURL ? "True" : "False",
    IsMobile: el?.IsMobile ? "True" : "False",
  }));

  if (
    !WpSetupDetailData ||
    !WpSetupData
  ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {editId ? "Update Wp Setup Detail" : "Add Wp Setup Detail"}
            {/* WhatsApp Setup Details */}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* WhatsApp Official Name Dropdown */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">WhatsApp Official Name</h5>
              {editId ? (
                <>
                  <input
                    type="text"
                    name="whaSlabName"
                    value={formData.WhatsappOffcialName}
                    readOnly
                    className="bg-gray-200 text-gray-700 w-full p-[10px] border-2 border-black rounded cursor-not-allowed"
                  />
                </>
              ) : (
                <>
                  <select
                    name="WhatsappOffcialName"
                    value={formData.WhatsappOffcialName}
                    onChange={(e) => {
                      const selectedName = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        WhatsappOffcialName: selectedName,
                      }));

                      const selectedItem = WpSetupData?.find(
                        (item) => item.WhatsappOffcialName === selectedName
                      );
                      setSelectedId(selectedItem ? selectedItem._id : null);
                    }}
                    className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
                  >
                    <option value="">Select Name</option>
                    {[...(WpSetupData || [])]
                      .sort((a, b) => (a.WhatsappOffcialName || "").localeCompare(b.WhatsappOffcialName || ""))
                      .map((option) => (
                        <option
                          key={option._id}
                          value={option.WhatsappOffcialName}
                        >
                          {option.WhatsappOffcialName}
                        </option>
                      ))}
                  </select>
                </>
              )}

              {errors.WhatsappOffcialName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.WhatsappOffcialName}
                </p>
              )}
            </div>

            {/* Parameter Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Parameter</h5>
              <input
                type="text"
                name="Parameter"
                // placeholder="Enter Your Range"
                value={formData.Parameter}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Parameter && (
                <p className="text-red-500 text-sm mt-1">{errors.Parameter}</p>
              )}
            </div>

            <div className="col-span-12 xl:col-span-2 lg:col-span-3 md:col-span-6">
              <div className="gap-4 justify-center items-center lg:ms-2">
                {/* Check ISURL */}
                <div className="flex items-center lg:mt-6 space-x-2">
                  <input
                    type="checkbox"
                    name="ISURL"
                    checked={formData.ISURL || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        ISURL: e.target.checked,
                      }))
                    }
                    className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                  />
                  <label htmlFor="ISURL" className="text-base font-semibold">
                    Is Url
                  </label>
                </div>

                {/* Check IsMobile */}
                <div className="flex items-center mt-3 space-x-2">
                  <input
                    type="checkbox"
                    name="IsMobile"
                    checked={formData.IsMobile || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        IsMobile: e.target.checked,
                      }))
                    }
                    className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                  />
                  <label htmlFor="IsMobile" className="text-base font-semibold">
                    Is Mobile
                  </label>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                {editId ? "Update" : "Submit"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                  onClick={() => {
                    setFormData({
                      WhatsappOffcialName: "",
                      Parameter: "",
                      ISURL: false,
                      IsMobile: false,
                    });
                    setEditId(null);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
              View Whatsapp API Setup
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-3">
            <WpDynamicTable columns={columns} rows={rows} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Wp_Setup_Details;
